export const dmsFr = {
  archive: {
    title: 'Archives documentaires',
    subtitle:
      'Archives centrales pour les documents généraux, les contrats, les enregistrements et les modèles.',
  },
  manager: {
    title: 'Documents et fichiers',
    description: 'Fichiers protégés avec sommes de contrôle et historique traçable.',
  },
  upload: {
    dropTitle: 'Déposez les fichiers ici ou sélectionnez-les',
    dropHint: "PDF, JPG, PNG, WebP, TXT, CSV, DOCX ou XLSX · jusqu'à 50 Mo par fichier",
    select: 'Sélectionner des fichiers',
    categoryHint: "La catégorie sélectionnée s'applique à tous les fichiers de ce téléchargement.",
    success_one: 'Fichier {{count}} téléchargé.',
    success_other: 'Fichiers {{count}} téléchargés.',
  },
  search: { label: 'Rechercher des documents', placeholder: 'Nom, titre ou étiquette…' },
  fields: {
    title: "Nom d'affichage\nClé",
    category: 'Catégorie',
    tags: 'Balises (séparées par des virgules)',
    description: 'Description / remarque',
  },
  portal: {
    label: 'Partager dans le portail client',
    hint: 'Seuls les fichiers explicitement partagés sont visibles par les utilisateurs de ce client.',
    visible: 'Visible dans le portail',
  },
  categories: {
    GENERAL_FILE: 'Dossier général',
    CONTRACT: 'Contrat',
    CERTIFICATE: 'Certificat',
    DATASHEET: 'Fiche technique',
    INVOICE_RECEIPT: 'Facture / reçu',
    CORRESPONDENCE: 'Correspondance',
    CUSTOMS_DECLARATION: 'Déclaration en douane',
    IMAGE: 'Image',
  },
  actions: {
    preview: 'Aperçu',
    previewNamed: "Ouvrir l'aperçu pour {{name}}",
    download: 'Télécharger',
  },
  item: { uploaded: '{{date}} · {{user}}' },
  empty: {
    title: "Aucun fichier pour l'instant",
    description: 'Ajoutez les premiers documents par glisser-déposer.',
    search: 'Aucun document ne correspond à votre recherche.',
  },
  edit: { title: 'Modifier le document', success: 'Détails du document enregistrés.' },
  delete: {
    title: 'Supprimer définitivement le document ?',
    description:
      "« {{name}} » sera supprimé de l'archive et du stockage protégé. L'opération reste dans le journal d'audit.",
    success: 'Document supprimé.',
  },
  preview: {
    error: "L'aperçu n'a pas pu être chargé.",
    previousPage: 'Page précédente',
    nextPage: 'Page suivante',
    page: 'Page',
    zoom: 'Zoomer',
    zoomIn: 'Zoom avant',
    zoomOut: 'Zoom arrière',
    rotateLeft: 'Rotation à gauche',
    rotateRight: 'Rotation à droite',
    fullscreen: 'Plein écran',
    textTruncated: "L'aperçu du texte a été raccourci pour que le spectateur reste réactif.",
    uploadedAt: 'Téléversé sur {{date}}',
  },
  errors: {
    list: "Les documents n'ont pas pu être chargés.",
    download: 'Le téléchargement a échoué.',
    entityMissing: "L'entité ERP associée est manquante.",
    size: '« {{name}} » est vide ou dépasse 50 Mo.',
    uploadFile: "« {{name}} » n'a pas pu être téléchargé.",
  },
  tabs: {
    partner: 'Documents et contrats',
    product: 'Fichiers et fiches techniques',
    documentDetails: 'Données du document',
    documentAttachments: 'Pièces jointes',
  },
  batch: {
    title: 'Documents par lots',
    subtitle: '{{product}} · Lot {{batch}}',
    back: 'Retour au produit',
    filesTitle: "Certificats d'analyses et rapports de laboratoire",
    loadError: "Le lot n'a pas pu être chargé.",
  },
} as const;
